/*----------------------------------
- OPPORTUNITIES WORKFLOW MOTION
- Decorative fake-data preview of the daily trend-led Opportunities feed:
- a fresh match arrives on top with a highlight, gets saved (plus to check),
- and the queue advances with a soft exit fade.
----------------------------------*/

import Icon from '@/client/components/ui/icon/Icon';

/*----------------------------------
- CONTENT
----------------------------------*/

const DAILY_OPPORTUNITIES = [
    {
        domain: 'gridshift.ai',
        topic: 'Grid investment',
        status: 'Available',
        price: '$2,480',
        idea: 'Forecasting workspace for energy teams',
        tone: 'sage',
    },
    {
        domain: 'coinrail.co',
        topic: 'Stablecoin payments',
        status: 'Premium',
        price: '$3,900',
        idea: 'Payment routing for global marketplaces',
        tone: 'amber',
    },
    {
        domain: 'orbitbase.io',
        topic: 'Lunar missions',
        status: 'Auction',
        price: '$1,250',
        idea: 'Mission planning for small satellite teams',
        tone: 'blue',
    },
] as const;

/*----------------------------------
- COMPONENT
----------------------------------*/

const OpportunitiesWorkflowMotion = () => (
    <div aria-hidden="true" class="ud-workflow-opportunities">
        <span class="ud-workflow-opportunities__today">Today · 3 new</span>
        <span class="ud-workflow-opportunities__fresh">
            <Icon name="trending-up" size={10} strokeWidth={2.2} />
            Fresh today
        </span>

        <div class="ud-workflow-opportunities__queue">
            {DAILY_OPPORTUNITIES.map((opportunity, index) => (
                <div
                    key={opportunity.domain}
                    class="ud-workflow-opportunities__card"
                    style={{ animationDelay: `${index * -3}s` }}
                >
                    <span class="ud-workflow-opportunities__glow" />
                    <span class="ud-workflow-opportunities__new">New match</span>
                    <span
                        class={`ud-workflow-opportunities__avatar ud-workflow-opportunities__avatar--${opportunity.tone}`}
                    >
                        {opportunity.domain[0].toUpperCase()}
                    </span>
                    <span class="ud-workflow-opportunities__domain-copy">
                        <span class="ud-workflow-opportunities__domain-line">
                            <strong>{opportunity.domain}</strong>
                            <span>{opportunity.topic}</span>
                        </span>
                        <span class="ud-workflow-opportunities__idea">{opportunity.idea}</span>
                        <span
                            class={`ud-workflow-opportunities__meta ud-workflow-opportunities__meta--${opportunity.tone}`}
                        >
                            <span>{opportunity.status}</span>
                            <strong>{opportunity.price}</strong>
                        </span>
                    </span>
                    <span class="ud-workflow-opportunities__save">
                        <Icon
                            className="ud-workflow-opportunities__save-plus"
                            name="plus"
                            size={11}
                            strokeWidth={2.2}
                        />
                        <Icon
                            className="ud-workflow-opportunities__save-check"
                            name="check"
                            size={11}
                            strokeWidth={2.4}
                        />
                    </span>
                </div>
            ))}
        </div>
    </div>
);

export default OpportunitiesWorkflowMotion;
